export default "__VITE_ASSET__eA$cUept__"